import { setAVLData, setHoboData, setSparkData } from "../redux/actions/websocket-actions";
import { setReadyWebsocketData } from "../redux/actions/shared-actions";
import store from "../redux/store";

const websocketCurrentData = store.getState().websocket;

/**
 * Contains websocket-data functions.
 * @namespace websocket_data
 * @category Services
 */
// eslint-disable-next-line
const websocket_data = {};
//used for the namespace in the documentation

/**
 * holds functions for dispatching websocket data
 * @memberof websocket_data
 * @object
 */
const dataUpdaters = {
  avl: (value) => {
    store.dispatch(setAVLData(value));
  },
  hobo: (value) => {
    store.dispatch(setHoboData(value));
  },
  spark: (value) => {
    store.dispatch(setSparkData(value));
  },
};

/**
 * Updates the websocket data state on every pong from the websocket connection.
 * @memberof websocket_data
 * @function updateWebsocketData
 */

export const updateWebsocketData = (websocketData) => {
  Object.entries(websocketData).forEach(([type, data]) => {
    if (data) {
      data.forEach((el) => {
        if (!el.id) {
          if (el.vehicleType === "tram") {
            if (el.line) {
              el.line = "TM" + el.line;
            }
            websocketCurrentData[type]["trams"][el.vehicleId] = el;
          }
          if (el.vehicleType === "bus") {
            if (el.line) {
              el.line = "A" + el.line;
            }
            websocketCurrentData[type]["buses"][el.vehicleId] = el;
          }
          if (el.vehicleType === "trolley") {
            if (el.line) {
              el.line = "TB" + el.line;
            }
            websocketCurrentData[type]["trolleysAndEBuses"][el.vehicleId] = el;
          }
        } else {
          websocketCurrentData[type][el.id] = el;
        }
      });
      dataUpdaters[type](websocketCurrentData[type]);
    }
  });
  if (!store.getState().shared.readyWebsocketData) {
    store.dispatch(setReadyWebsocketData(true));
  }
};
